import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import { isDevAutofillEnabled } from '../../utils/devAutofill';

interface DevAutofillButtonProps {
    onAutofill: () => void;
    title?: string;
    /** Theme highlight / gold token */
    color?: string;
    size?: 'small' | 'medium';
}

export function DevAutofillButton({
    onAutofill,
    title = 'Dev: auto-fill',
    color = '#ffc965',
    size = 'small',
}: DevAutofillButtonProps) {
    if (!isDevAutofillEnabled()) return null;

    const dimension = size === 'small' ? 32 : 36;

    return (
        <Tooltip title={title} arrow>
            <IconButton
                onClick={onAutofill}
                size={size}
                aria-label={title}
                sx={{
                    color,
                    bgcolor: 'rgba(255,201,101,0.08)',
                    border: '1px dashed rgba(255,201,101,0.3)',
                    '&:hover': { bgcolor: 'rgba(255,201,101,0.18)' },
                    width: dimension,
                    height: dimension,
                    flexShrink: 0,
                }}>
                <BoltIcon sx={{ fontSize: size === 'small' ? 18 : 20 }} />
            </IconButton>
        </Tooltip>
    );
}
